import { PartnerApiDocsPreStyled } from "../styled/PartnerApiDocsStyled";
import { Table } from "react-bootstrap";
import { PARTNER_API_DOCS_DEFAULT_PARAMETERS } from "./partnerApiDocsInfoConstant";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

function PartnerApiDocsInfo(props) {
    const {getLangPath} = useLangContext();
    return <>
        <h1>{getLangPath('partner.api_docs.title')}</h1>
        <p>{getLangPath('partner.api_docs.api_doc_description')}</p>

        <h4 className="mt-5">{getLangPath('partner.api_docs.default_parameters')}</h4>
        <Table striped bordered hover variant="dark">
            <thead>
            <tr>
                <th>{getLangPath('partner.api_docs.name')}</th>
                <th>{getLangPath('partner.api_docs.description')}</th>
                <th>{getLangPath('partner.api_docs.type')}</th>
            </tr>
            </thead>
            <tbody>
            {
                PARTNER_API_DOCS_DEFAULT_PARAMETERS.map(param => (
                        <tr key={param.name}>
                            <td>{param.name}</td>
                            <td>{getLangPath(param.description)}</td>
                            <td>{getLangPath(param.type)}</td>
                        </tr>
                ))
            }
            </tbody>
        </Table>

        <h4 className="mt-5">{getLangPath('partner.api_docs.service_api_url')}</h4>
        <PartnerApiDocsPreStyled>
            https://fx.binomo.com/api/v1/public/partner/[METHOD]
        </PartnerApiDocsPreStyled>
    </>
}

export default PartnerApiDocsInfo;
